import { render, staticRenderFns } from "./SurveyBody.vue?vue&type=template&id=8ea10644&"
import script from "./SurveyBody.vue?vue&type=script&lang=ts&"
export * from "./SurveyBody.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyBody.vue?vue&type=style&index=0&id=8ea10644&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports